<!-- eslint-disable max-len -->
<template>
  <div class="bg-blue-800 h-full w-full">
    <div class="container mx-auto px-4 h-full pt-24 min-h-screen">
      <div class="flex content-center items-center justify-center h-full">
        <div class="w-full lg:w-4/12 px-4">
          <div
            class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blue-100 border-0"
          >
            <div class="flex-auto px-4 lg:px-10 py-10 pt-0">
              <div class=" mb-3">
                <img class="m-auto" src="@/assets/musicverse-logo.png" style="width: 150px"/>
              </div>
              <form @submit="login" >
                <div class="relative w-full mb-3 text-left">
                  <label
                    class="block uppercase text-blue-800 text-xs font-bold mb-2"
                    for="grid-password"
                  >
                    Email
                  </label>
                  <input
                    type="email"
                    class="border-0 px-3 py-3 placeholder-blue-300 text-blue-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    placeholder="Email"
                    name="email"
                    v-model="email"
                  />
                </div>

                <div class="relative w-full mb-3 text-left">
                  <label
                    class="block uppercase text-blue-800 text-xs font-bold mb-2"
                    for="grid-password"
                  >
                    Password
                  </label>
                  <input
                    type="password"
                    class="border-0 px-3 py-3 placeholder-blue-300 text-blue-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    placeholder="Password"
                    name="password"
                    v-model="password"
                  />
                </div>
                <p v-if="getStatus !== 200" class="text-red-500 text-xs italic text-left">{{ getMessage }}. </p>
                <p v-if="isErrorVerification" class="text-xs italic text-left" >Click <router-link :to="{ name: 'SendVerification', params: { email: this.email } }" class="text-blue-500" >here</router-link> to resend email verification</p>
                <div class="text-center mt-6">
                  <button
                    class="bg-blue-600 text-white hover:bg-blue-800 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                    type="submit"
                    @click="login"
                    :disabled="isLoading"
                    :class="isLoading ? 'cursor-not-allowed' : ''"
                  >
                    Sign In
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div class="flex flex-wrap mt-6 relative">
            <div class="w-1/2 text-left">
              <router-link :to="{ name: 'ForgotPassword', params: { email: email } }" class="text-blue-200 font-bold">
                  <small>Forgot password?</small>
              </router-link>
            </div>
            <div class="w-1/2 text-right">
              <router-link to="/register" class="text-blue-200 font-bold">
                <small>Create new account</small>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
<!--  <div>-->
<!--    <nav-->
<!--      class="bg-gray-900 pt-2 md:pt-1 pb-1 px-1 mt-0 h-auto fixed w-full z-20 top-0"-->
<!--      style="height: 50px;"-->
<!--    >-->
<!--    </nav>-->
<!--    <div class="flex flex-col md:flex-row">-->
<!--      <div class="main-content flex-1 bg-gray-100 mt-12 md:mt-2">-->
<!--        <div class="bg-blue-800 p-2 shadow text-xl text-white">-->
<!--          <div class="bg-grey-lighter min-h-screen flex flex-col">-->

<!--            &lt;!&ndash; eslint-disable max-len &ndash;&gt;-->
<!--            <div-->
<!--              class="container max-w-sm mx-auto flex-1 flex flex-col items-center justify-center px-2"-->
<!--            >-->
<!--            &lt;!&ndash; eslint-enable max-len &ndash;&gt;-->
<!--              <div class="bg-white px-6 py-8 rounded shadow-md text-black w-full">-->
<!--                <img class="m-auto" src="@/assets/musicverse-logo.png" style="width: 150px"/>-->
<!--                <h1 class="mb-8 text-3xl text-center">Sign in</h1>-->
<!--                <form @submit="login" >-->
<!--                  <input-->
<!--                    :type="'text'"-->
<!--                    class="block border border-grey-light w-full p-3 rounded mb-4"-->
<!--                    name="email"-->
<!--                    placeholder="Email"-->
<!--                    v-model="email"-->
<!--                  />-->
<!--                  <div class="relative">-->
<!--                    <input-->
<!--                      :type="showPassword?'text':'password'"-->
<!--                      class="block border border-grey-light w-full p-3 rounded mb-4"-->
<!--                      name="password"-->
<!--                      placeholder="Password"-->
<!--                      v-model="password"-->
<!--                    />-->
<!--                    <a class="absolute top-0 right-0 mr-2 mt-3 " @click="showPassword=!showPassword" style="cursor:pointer">-->
<!--                      <font-awesome-icon class="text-blue-500" :icon="['fa', showPassword?'eye-slash':'eye']" />-->
<!--                    </a>-->
<!--                  </div>-->
<!--                  &lt;!&ndash; eslint-disable max-len &ndash;&gt;-->
<!--                  <p v-if="getStatus !== 200" class="text-red-500 text-xs italic text-left">{{ getMessage }}. </p>-->
<!--                  <p v-if="isErrorVerification" class="text-xs italic text-left" >Click <router-link :to="{ name: 'SendVerification', params: { email: this.email } }" class="text-blue-500" >here</router-link> to resend email verification</p>-->
<!--                  <button-->
<!--                    type="submit"-->
<!--                    @click="login"-->
<!--                    :disabled="isLoading"-->
<!--                    :class="isLoading ? 'cursor-not-allowed' : ''"-->
<!--                    class="w-full text-center py-3 rounded bg-blue-400 text-white hover:bg-blue-600 focus:outline-none my-1"-->
<!--                  >-->
<!--                    {{ labelSave }}<img v-if="isLoading" src="@/assets/bars.svg" width="30px" class="m-auto" />-->
<!--                  </button>-->
<!--                  &lt;!&ndash; eslint-enable max-len &ndash;&gt;-->
<!--                </form>-->
<!--                <div class="text-center text-sm text-grey-600 mt-4">-->
<!--                  <router-link :to="{ name: 'ForgotPassword', params: { email: email } }" >-->
<!--                    <a class="no-underline border-b border-grey-600 text-grey-600 cursor-pointer">-->
<!--                      Forgot Password?-->
<!--                    </a>-->
<!--                  </router-link>-->
<!--                </div>-->
<!--                <div class="text-grey-600 mt-6">-->
<!--                  Don't have an account?-->
<!--                  <router-link to='/register' >-->
<!--                  <a-->
<!--                    class="no-underline border-b border-blue text-blue"-->
<!--                    href="#"-->
<!--                  >-->
<!--                    Create one-->
<!--                  </a>-->
<!--                  </router-link>.-->
<!--                </div>-->
<!--                </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import clevertap from 'clevertap-web-sdk';
import * as moment from 'moment';

export default {
  name: 'Signin',
  data: () => ({
    isLoading: false,
    showPassword: false,
    email: '',
    password: '',
    isErrorVerification: '',
  }),
  computed: {
    ...mapGetters('NotificationModule', ['getLoading', 'getStatus', 'getMessage', 'getErrorCode']),
    ...mapGetters('AuthModule', ['getRole']),
    labelSave() {
      return !this.isLoading ? 'Login' : '';
    },
  },
  watch: {
    getLoading: {
      immediate: true,
      handler(val) {
        this.isLoading = val;
      },
    },
    getMessage: {
      immediate: true,
      handler(val) {
        this.isErrorVerification = val.toLowerCase().includes('please verify your email');
      },
    },
  },
  methods: {
    ...mapActions('AuthModule', ['requestAuthentication']),
    async login(e) {
      e.preventDefault();
      try {
        // eslint-disable-next-line max-len
        const response = await this.requestAuthentication({ user: { email: this.email, password: this.password } });
        if (response) {
          clevertap.onUserLogin.push({
            Site: {
              Name: response.data.user.name,
              Identity: response.data.user.id,
              Email: response.data.user.email,
              DOB: response.data.user.dob ? moment(response.data.user.dob).toDate() : null,
              'Acquisition Type': 'Website',
              Bio: response.data.user.bio,
              'Registration Date': response.data.user.registration_date,
              'Number of album upload till date': response.data.user.number_of_uploaded_album,
              'Number of song upload till date': response.data.user.number_of_uploaded_song,
              Balance: response.data.user.balance,
              'Total earning till date': response.data.user.earning,
              'First album upload date': response.data.user.first_upload_album_date,
              'Recent album upload': response.data.user.recent_upload_album_date,
              'First song upload date': response.data.user.first_upload_song_date,
              'Recent song upload': response.data.user.recent_upload_song_date,
            },
          });
          setTimeout(() => {
            clevertap.event.push('Logged in', {
              'Method Used': 'Email',
              Email: response.data.user.email,
              Detail: 'Success',
              Status: 'Success',
            });
          }, 1000);
          if (response.data.user.role === this.getRole.FINANCE) {
            this.$router.push({ name: 'PayoutList' });
          } else {
            this.$router.push({ name: 'Dashboard' });
          }
        } else if (this.getStatus !== 200) {
          clevertap.event.push('Logged in', {
            'Method Used': 'Email',
            Detail: this.getMessage,
            Status: 'Failed',
          });
        }
      } catch (err) {
        // console.log(err);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Signin.vue